/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ContainersService } from './services/containers.service';
import { ContractorPenaltyService } from './services/contractor-penalty.service';
import { DistrictService } from './services/district.service';
import { KpiReportsService } from './services/kpi-reports.service';
import { LocationService } from './services/location.service';
import { MunicipalService } from './services/municipal.service';
import { NotificationCenterService } from './services/notification-center.service';
import { PlanService } from './services/plan.service';
import { PortfolioService } from './services/portfolio.service';
import { ProgramService } from './services/program.service';
import { ProjectService } from './services/project.service';
import { ProjectCategoriesService } from './services/project-categories.service';
import { ProjectCategoriesKpIsService } from './services/project-categories-kp-is.service';
import { ProjectChangeOrdersService } from './services/project-change-orders.service';
import { ProjectCostChangesService } from './services/project-cost-changes.service';
import { ProjectDailyReportsService } from './services/project-daily-reports.service';
import { ProjectItemsService } from './services/project-items.service';
import { ProjectMaintenanceReportsService } from './services/project-maintenance-reports.service';
import { ProjectPenaltiesService } from './services/project-penalties.service';
import { ProjectPenaltiesTemplateService } from './services/project-penalties-template.service';
import { ProjectPenaltyDetailsTemplateService } from './services/project-penalty-details-template.service';
import { ProjectPerformanceIndicatorService } from './services/project-performance-indicator.service';
import { ProjectProgressService } from './services/project-progress.service';
import { ProjectStagesService } from './services/project-stages.service';
import { ProjectTasksService } from './services/project-tasks.service';
import { ProjectTimeUpdatesService } from './services/project-time-updates.service';
import { ProjectFinancialClaimsDetailsService } from './services/project-financial-claims-details.service';
import { ProjectFinancialSummariesService } from './services/project-financial-summaries.service';
import { ProjectItemSamplesService } from './services/project-item-samples.service';
import { ProjectItemSubmittalsService } from './services/project-item-submittals.service';
import { ProjectLocationsService } from './services/project-locations.service';
import { SectorService } from './services/sector.service';
import { SettingsPenaltiesService } from './services/settings-penalties.service';
import { SettingsPenaltyDetailsService } from './services/settings-penalty-details.service';
import { SettingsProjectResourcesService } from './services/settings-project-resources.service';
import { SettingsUnitsService } from './services/settings-units.service';
import { SettingsVendorsService } from './services/settings-vendors.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ContainersService,
    ContractorPenaltyService,
    DistrictService,
    KpiReportsService,
    LocationService,
    MunicipalService,
    NotificationCenterService,
    PlanService,
    PortfolioService,
    ProgramService,
    ProjectService,
    ProjectCategoriesService,
    ProjectCategoriesKpIsService,
    ProjectChangeOrdersService,
    ProjectCostChangesService,
    ProjectDailyReportsService,
    ProjectItemsService,
    ProjectMaintenanceReportsService,
    ProjectPenaltiesService,
    ProjectPenaltiesTemplateService,
    ProjectPenaltyDetailsTemplateService,
    ProjectPerformanceIndicatorService,
    ProjectProgressService,
    ProjectStagesService,
    ProjectTasksService,
    ProjectTimeUpdatesService,
    ProjectFinancialClaimsDetailsService,
    ProjectFinancialSummariesService,
    ProjectItemSamplesService,
    ProjectItemSubmittalsService,
    ProjectLocationsService,
    SectorService,
    SettingsPenaltiesService,
    SettingsPenaltyDetailsService,
    SettingsProjectResourcesService,
    SettingsUnitsService,
    SettingsVendorsService,
    ApiConfiguration
  ],
})
export class PMApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<PMApiModule> {
    return {
      ngModule: PMApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: PMApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('PMApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
